module.exports = "<span>{{ term }}</span>\n"